import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    OnDestroy,
    OnInit,
    ViewEncapsulation,
} from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EmailField } from "./email";
import { BaseFieldEditorComponent } from "../../base-field-editor.component";

@Component({
    selector: "field-editor-email",
    templateUrl: "./email-editor.component.html",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailFieldEditorComponent extends BaseFieldEditorComponent implements OnInit, OnDestroy {
    form: FormGroup;

    constructor(_changeDetector: ChangeDetectorRef, private _formBuilder: FormBuilder) {
        super(_changeDetector);
    }

    ngOnInit(): void {
        this.form = this._formBuilder.group({
            placeholder: [this.emailField.placeholder],
        });
        super.onInit();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    get emailField() {
        return this.field as EmailField;
    }
}
